import React, { FC } from "react";
import { Table as AntTable } from "antd";
import { TableProps } from "./types";
import { Wrapper } from "./elements";

const Table: FC<TableProps> = (props) => {
  const {
    tableData,
    columns,
    components,
    rowClassName,
    isLoading,
    rowRecord,
    showHeader,
    hidePagination,
    onChange,
    totalItems,
    current,
    scroll,
  } = props;

  return (
    <Wrapper rowRecord={rowRecord}>
      <AntTable
        loading={isLoading}
        pagination={
          hidePagination
            ? false
            : {
                position: ["bottomCenter"],
                defaultPageSize: 10,
                showSizeChanger: true,
                total: totalItems || 0,
                current,
              }
        }
        components={components || null}
        rowClassName={rowClassName}
        columns={columns}
        dataSource={tableData}
        onRow={(record) => {
          return {
            onClick: () => rowRecord && rowRecord(record),
          };
        }}
        onChange={onChange}
        showHeader={showHeader}
        scroll={scroll || { x: 0 }}
      />
    </Wrapper>
  );
};

export default Table;
